export const GIFTS_PRICES = {
  RELEVANCE: {
    name: 'Relevancia',
    value: '',
  },
  LOWER_PRICE: {
    name: 'Menor precio',
    value: 'sale_price:A:Y',
  },
  HIGHER_PRICE: {
    name: 'Mayor precio',
    value: 'sale_price:D:Y',
  },
};

export const GIFTS_PRICES_CATALOG = Object.values(GIFTS_PRICES).map(
  (value) => value
);
